import { Form } from 'factorial-form'

class TaxResidenceForm extends Form {
  constructor(values: Record<string, boolean | string | number | undefined>) {
    super(values, {
      is_resident: 'boolean',
      employee_id: 'string',
      city_of_birth: 'string',
      country_of_birth: 'string',
    })
  }
}

export default TaxResidenceForm
